import { Link, type SxProps, type Theme } from '@mui/material';
import { usePrivacyNotice } from './hooks/usePrivacyNotice';

export const PRIVACY_NOTICE_LABEL = 'Privacy notice';

/** The notice lives on the organisation's own site, so it opens in a new tab without handing it this page. */
export const EXTERNAL_LINK_PROPS = { target: '_blank', rel: 'noopener noreferrer' } as const;

/**
 * The organisation's privacy notice, as a text link (the sign-in page, About).
 * Absent until an admin sets the URL. The sidebar draws its own, in its
 * footer-link style, from the same hook.
 */
export function PrivacyNoticeLink({ sx }: { sx?: SxProps<Theme> }) {
  const url = usePrivacyNotice();
  if (!url) return null;
  return (
    <Link href={url} {...EXTERNAL_LINK_PROPS} aria-label={`${PRIVACY_NOTICE_LABEL} (opens in a new tab)`} sx={sx}>
      {PRIVACY_NOTICE_LABEL}
    </Link>
  );
}
